import { useLocation, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20">
        <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
          <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
            404
          </h1>
          <div className="relative z-10">
            <span className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-6">
              <i className="ri-emotion-sad-line text-primary-500 text-4xl"></i>
            </span>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 font-heading">
              页面不存在
            </h1>
            <p className="text-sm text-foreground-500 font-mono mb-4">{location.pathname}</p>
            <p className="text-base text-foreground-600 mb-6">
              您访问的页面不存在或已被移除
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line"></i>
              返回首页
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}